export const UserDetailItem = ({ label, value }) => {
  return (
    <div className="w-full">
      <p className="text-gray-400 max-lg:text-sm text-[15px]">{label}</p>
      <p className="max-lg:text-sm">{value || "-"}</p>
    </div>
  );
};

export const UserDetailsWrapper = ({ children }) => {
  return <div className="px-3 py-2 flex gap-4">{children}</div>;
};

export const UserInfoBoxTitle = ({ title }) => {
  return (
    <h3 className="border-b-2 lg:text-lg p-2 px-3 font-figtreeBold text-black">
      {title}
    </h3>
  );
};

export const UserBoxWrapper = ({ children }) => {
  return <div className="rounded-md shadow-md border-1">{children}</div>;
};
